import { render, staticRenderFns } from "./YearGroups.vue?vue&type=template&id=32a27580&scoped=true&"
import script from "./YearGroups.vue?vue&type=script&lang=js&"
export * from "./YearGroups.vue?vue&type=script&lang=js&"
import style0 from "./YearGroups.vue?vue&type=style&index=0&id=32a27580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a27580",
  null
  
)

export default component.exports